export const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));

// progress 0..1 as element enters viewport from bottom
export function passP(r, vh) {
  return clamp((vh - r.top) / (vh + r.height));
}

// over-scroll: how far past the top of viewport
export function overP(r, vh, k = 1.5) {
  return clamp(-r.top / (vh * k));
}

// 1 when element center is at viewport center, 0 when fully out
export function centerPeak(r, vh) {
  const c = r.top + r.height / 2;
  const dist = Math.abs(c - vh / 2);
  const max = (vh + r.height) / 2;
  return clamp(1 - dist / max);
}
